import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SwiperModule } from 'swiper/angular';
import { AccountComponent } from './account/account.component';
import { AdvisoryBoardComponent } from './advisory-board/advisory-board.component';
import { AuthGuard } from './auth.guard';
import { CatalogueComponent } from './catalogue/catalogue.component';
import { CollectingComponent } from './collecting/collecting.component';
import { CollectionDetailsComponent } from './collection-details/collection-details.component';
import { DonationsComponent } from './donations/donations.component';
import { EreaderComponent } from './ereader/ereader.component';
import { ErrorPageComponent } from './error-page/error-page.component';
import { EventsComponent } from './events/events.component';
import { EventsdetailsComponent } from './eventsdetails/eventsdetails.component';
import { HomeComponent } from './home/home.component';
import { RedirectComponent } from './home/redirect.Component';
import { LinksComponent } from './links/links.component';
import { LoginComponent } from './login/login.component';
import { MissionStatementComponent } from './mission-statement/mission-statement.component';
import { OnlineshopComponent } from './onlineshop/onlineshop.component';
import { OnlineshopdetailsComponent } from './onlineshopdetails/onlineshopdetails.component';
import { PaymentsComponent } from './payments/payments.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';
import { ShopproductComponent } from './shopproduct/shopproduct.component';
import { Paymentsub } from './userpage/paymentsub.component';
import { UserpageComponent } from './userpage/userpage.component';
import { CategoryComponent } from './category/category.component';
import { CategoryitemsComponent } from './categoryitems/categoryitems.component';


const routes: Routes = [
  {path: '', component: HomeComponent },
  {path: 'catalogs', component: CatalogueComponent,canActivate:[AuthGuard] },
  {path: 'event/:eventname/:page', component: EventsComponent },
  {path: 'eventdetails/:eventname/:eventid', component: EventsdetailsComponent },
  {path: 'donation', component: DonationsComponent },
  {path: 'onlineshop/:page', component: OnlineshopComponent },
  {path: 'onlineshopdetails/:id', component: OnlineshopdetailsComponent },
  {path: 'collection/:page', component: CollectingComponent },
  {path: 'collectiondetails/:collid', component: CollectionDetailsComponent },
  {path: 'advisoryboard', component: AdvisoryBoardComponent },
  {path: 'myaccount', component: AccountComponent},
  {path: 'link', component: LinksComponent },
  {path: 'resetpassword', component: ResetpasswordComponent },
  {path: 'privacy', component: PrivacyPolicyComponent },
  {path: 'userpage', component: UserpageComponent,canActivate:[AuthGuard]  },
  {path: 'shipment', component: ShopproductComponent },
  {path: 'priceGuide', component: RedirectComponent,canActivate:[AuthGuard]  },
  {path: 'login', component: HomeComponent },
  {path: 'antique-phonograph-society-mission-statement', component: MissionStatementComponent },
  {path: 'payment/:payment', component: PaymentsComponent },
  {path: 'myaccount/:payment', component: AccountComponent },
  {path: 'subpayment/:payment', component:Paymentsub,canActivate:[AuthGuard]  },
  {path: 'ereader/:page',component:EreaderComponent,canActivate:[AuthGuard]},
  {path: 'category/:page',component:CategoryComponent,canActivate:[AuthGuard]},
  {path: 'categoryitem/:page',component:CategoryitemsComponent,canActivate:[AuthGuard]},
  {path: '**', component: ErrorPageComponent },
 
  



  
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{useHash: true,scrollPositionRestoration: 'enabled',anchorScrolling: 'enabled',
  scrollOffset: [0, 64]}),
    SwiperModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
